<div leaflet
     [leafletOptions]="options"
     (leafletMapReady)="onMapReady($event)"
     (leafletMapZoomEnd)="onMapZoomEnd($event)"
     id='waypoints-lap-map'
>
     <mat-dialog-actions align="end" style="position: absolute; top: 10px; right: 10px; z-index: 1000;">
          <button mat-button mat-dialog-close style="color: #fafafa; background-color: #3f51b5;" (click)="unsub()">Chiudi</button>
     </mat-dialog-actions>
</div>